import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=43d9f89c&scoped=true&"
import script from "./rules.vue?vue&type=script&lang=js&"
export * from "./rules.vue?vue&type=script&lang=js&"
import style0 from "./rules.vue?vue&type=style&index=0&id=43d9f89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d9f89c",
  null
  
)

export default component.exports